import type { Exercise, Workout } from '@jungles/shared';

// Canonical order from the seeded exercise catalog, not workout insertion order.
const MUSCLE_GROUPS = ['Грудь', 'Спина', 'Плечи', 'Ноги', 'Ягодицы', 'Руки', 'Кор'];

/** Display only: preserve stored names, templates, drafts and meaningful custom titles. */
export function workoutHistoryTitle(workout: Workout, catalog: Exercise[] | null): string {
  if (workout.type !== 'strength' || workout.status !== 'done' || workout.templateId ||
      !['Своя тренировка', 'Своя'].includes(workout.title) || !catalog) return workout.title;
  const byId = new Map(catalog.map((exercise) => [exercise.id, exercise.muscleGroup]));
  const groups = new Set(workout.exercises
    // Same performed-set semantics as API volumeOf/setsCountOf; zero is valid.
    .filter((exercise) => exercise.sets.some((set) => set.done || (set.weightKg !== null && set.reps !== null)))
    .map((exercise) => byId.get(exercise.exerciseId)));
  return MUSCLE_GROUPS.filter((group) => groups.has(group)).join(' + ') || 'Своя';
}
